import "./loader.css";
import logo from "../img/carbon.png";

export default function Loader({ fade }) {
  return (
    <div className={`loaderOverlay ${fade ? "fade" : ""}`}>
      <img src={logo} className="loaderLogo" alt="logo" />
    </div>
  );
}